// extracted by mini-css-extract-plugin
export default {"wrapper":"OptionSelector_wrapper__rqy8A","label":"OptionSelector_label__ksMni","selectInput":"OptionSelector_selectInput__wn9rJ"};